import React from 'react';

const SubmitButton = ({ loading, children }) => {
  return (
    <button type="submit" disabled={loading} style={{
      backgroundColor: loading ? 'gray' : 'blue',
      color: 'white',
      padding: '10px 20px',
      border: 'none',
      borderRadius: '5px',
      cursor: loading ? 'not-allowed' : 'pointer',
    }}>
      {loading ? 'Loading...' : children}
    </button>
  );
};

export default SubmitButton;
